import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab, FooterButton } from 'Core/components';
import CustomersAddEditForm from './customermasters-add-edit-form';
import CustomPropTypes from 'Core/prop-types';
import { addCustomer, editCustomer } from './store/slice';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import { all_routes } from '../../router/all_routes';

const CustomersAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const customersData = modalData;
  const [formData, setFormData] = useState(customersData || null);
  const [partsData, setPartsData] = useState(customersData?.parts || []);
  const [pickTicketsData, setPickTicketsData] = useState(customersData?.customersPickTickets || []);
  const [filesData, setFilesData] = useState(customersData?.shippingDocuments || []);

  const dispatch = useDispatch();
  const isEditMode = Boolean(customersData?.id);

  const onChangesCustomersForm = data => {
    setFormData(data);
  };

  const onChangesParts = data => {
    setPartsData(data);
  };

  const onChangesFiles = data => {
    setFilesData(data);
  };

  const onChangesPickTickets = data => {
    setPickTicketsData(data);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        <CustomersAddEditForm data={formData} onChanges={onChangesCustomersForm} />
      </div>
    );
  };

  const valid = () => {
    if (!formData ||
      !formData?.customerName ||
      !formData?.customerShortName ||
      !formData?.location ||
      !formData?.status
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields (Customer Name, Short Name, Location, Status)',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  const footer = () => {
    const onSave = () => {
      if (valid()) {
        const payload = {
          ...formData,
          userId: localStorage.getItem('UserId')
        };
        if (isEditMode) {
          dispatch(editCustomer(payload));
        } else {
          dispatch(addCustomer(payload));
        }
      }
    };

    return (
      <div className="row">
        <div className="col-12 col-lg-8"></div>
        <div className="col-12 col-lg-4">
          <FooterButton
            cancelText="Cancel"
            saveText="Save Customer"
            onSave={onSave}
            onCancel={handleClose}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal
      id="customers-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Edit Customers' : 'Add Customers'}
      body={body}
      footer={footer}
      handleClose={handleClose}
    />
  );
};

CustomersAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.object,
  onCloseModal: PropTypes.func,
};

export default AppModal(CustomersAddEdit);

